import { render } from "./Background.vue?vue&type=template&id=47224759"
const script = {}

import "./Background.vue?vue&type=style&index=0&id=47224759&lang=css"
script.render = render

export default script